/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Savecontactinformation2Inputs */

const en_savecontactinformation2 = /** @type {(inputs: Savecontactinformation2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Save Contact Information`)
};

const de_savecontactinformation2 = /** @type {(inputs: Savecontactinformation2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kontaktinformationen speichern`)
};

/**
* | output |
* | --- |
* | "Save Contact Information" |
*
* @param {Savecontactinformation2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const savecontactinformation2 = /** @type {((inputs?: Savecontactinformation2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Savecontactinformation2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_savecontactinformation2(inputs)
	return de_savecontactinformation2(inputs)
});
export { savecontactinformation2 as "saveContactInformation" }